import React, { useState, useEffect, useRef, Fragment } from "react";
import { ToastContainer, toast } from "react-toastify";
import "../App.css";
import "react-toastify/dist/ReactToastify.css";

import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme


import { BrowserRouter as Router, Link, Route } from "react-router-dom";

export const PositionsSubmit = () => {
  const [position, setPosition] = useState("");
  const [task, setTask] = useState("");

  const [positions, setPositions] = useState([]);
  const [tasks, setTasks] = useState([]);

  async function getPositions() {
    try {
      const getPos = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/getPositions`
      );
      const parsRes = await getPos.json();
      setPositions(parsRes);
    } catch (err) {
      console.error(err.message);
    }
  }

  async function getTasks() {
    try {
      const getTasks = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/getTasks`
      );
      const parsRes = await getTasks.json();
      setTasks(parsRes);
    } catch (err) {
      console.error(err.message);
    }
  }
  console.log(tasks);

  async function sendPosition() {
    try {
      if (position !== "") {
        const posSend = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/addPosition`,
          {
            method: "POST",
            headers: {
              "Content-type": "application/json",
            },
            body: JSON.stringify({ position }),
          }
        );
        if (posSend.ok) {
          // Execute getPositions function only on success
          getPositions();
        }
      }
    } catch (err) {
      console.error(err.message);
    }
  }

  async function sendTask() {
    try {
      if (task !== "") {
        const taskSend = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/addTask`,
          {
            method: "POST",
            headers: {
              "Content-type": "application/json",
            },
            body: JSON.stringify({ task }),
          }
        );
        if (taskSend.ok) {
          // Execute getPositions function only on success
          getTasks();
        }
      }
    } catch (err) {
      console.error(err.message);
    }
  }

  const handlePosAddSubmit = (e) => {
    e.preventDefault();
    sendPosition();
    // getPositions();
    document.getElementById("pos-add-btn").disabled = true;
    setPosition("");
  };

  const handleTaskAddSubmit = (e) => {
    e.preventDefault();
    sendTask();
    // getPositions();
    document.getElementById("task-add-btn").disabled = true;
    setTask("");
  };

  const handlePosTxtChange = (e) => {
    document.getElementById("pos-add-btn").disabled = false;

    setPosition(e.target.value);
  };

  const handleTaskTxtChange = (e) => {
    document.getElementById("task-add-btn").disabled = false;

    setTask(e.target.value);
  };

  useEffect(() => {
    getPositions();
    document.getElementById("pos-add-btn").disabled = true;
    getTasks();
    document.getElementById("task-add-btn").disabled = true;
  }, []);

  useEffect(() => {
    if (position == "") {
      document.getElementById("pos-add-btn").disabled = true;
    } else {
      document.getElementById("pos-add-btn").disabled = false;
    }
  }, [position]);

  useEffect(() => {
    if (task == "") {
      document.getElementById("task-add-btn").disabled = true;
    } else {
      document.getElementById("task-add-btn").disabled = false;
    }
  }, [task]);

  const toast = useRef(null);



  const handlePosDelete = async (id) => {
    // Add your logic to delete the item with the given id
    try {
      const posDelete = await fetch(`/api/posDelete/${id}`, {
        method: "DELETE",
        headers: { token: localStorage.token },
      });
      if (posDelete.ok) {
        accept();
        getPositions();
      }
    } catch (err) {
      console.error.message(err);
    }
  };

  const handlePosDelete2 = async (id) => {
    // Add your logic to delete the item with the given id
    try {
      const posDelete = await fetch(`/api/taskDelete/${id}`, {
        method: "DELETE",
        headers: { token: localStorage.token },
      });
      if (posDelete.ok) {
        accept();
        getTasks();
      }
    } catch (err) {
      console.error.message(err);
    }
  };


  const accept = () => {
    toast.current.show({
      severity: "info",
      summary: "conifrmé",
      detail: "Position supprimé",
      life: 3000,
    });
  };

  const reject = () => {
    toast.current.show({
      severity: "warn",
      summary: "Annulée",
      detail: "demande de suppression annulée",
      life: 3000,
    });
  };

  const confirm1 = (e, id) => {
    e.preventDefault();
    confirmDialog({
      message: "Confirmer la suppression de la position",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Oui",
      rejectLabel: "Non",
      accept: () => handlePosDelete(id),
      reject,
      className: "my-custom-confirm-dialog",
    });
  };

  const confirm2 = (e, id) => {
    e.preventDefault();
    confirmDialog({
      message: "Confirmer la suppression de la position",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Oui",
      rejectLabel: "Non",
      accept: () => handlePosDelete2(id),
      reject,
      className: "my-custom-confirm-dialog",
    });
  };


  return (
    <Fragment>
      <div className="flex flex-column gap-3">
        <h5 className="pos-submit-title text-center">
          Ajouter une position/fonction
        </h5>

        <div className="flex gap-3">
          <div className="flex flex-column gap-3">
            <form
              onSubmit={handlePosAddSubmit}
              className="pos-submit-form form-control"
            >
              <label className="label-control label" htmlFor="position">
                Titre de position
              </label>
              <input
                className="form-control"
                id="position"
                type="text"
                value={position}
                onChange={handlePosTxtChange}
              ></input>
              <button
                id="pos-add-btn"
                className="form-control btn btn-primary pos-add-btn"
              >
                Ajouter
              </button>
            </form>

            <div className="pos-current-list">
              <table className="pos-list-table table">
                <thead>
                  <tr>
                    <th></th>
                    <th>N°</th>
                    <th>Position</th>
                  </tr>
                </thead>
                <tbody>
                  {positions.map((position, index) => (
                    <tr key={position.role_id}>
                      <td>
                        <i onClick={(e) => confirm1(e, position.role_id)} className="pi pi-trash cursor-pointer text-gray-500 hover:text-red-500"></i>
                      </td>
                      <td>{index + 1}</td>
                      <td>{position.role_name}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="flex flex-column gap-3">
            <form
              onSubmit={handleTaskAddSubmit}
              className="pos-submit-form form-control"
            >
              <label className="label-control label" htmlFor="position">
                Titre de la fonction secondaire
              </label>
              <input
                className="form-control"
                id="position"
                type="text"
                value={task}
                onChange={handleTaskTxtChange}
              ></input>
              <button
                id="task-add-btn"
                className="form-control btn btn-primary pos-add-btn"
              >
                Ajouter
              </button>
            </form>
            <div className="task-current-list">
              <table className="pos-list-table table">
                <thead>
                  <tr>
                    <th></th>
                    <th>N°</th>
                    <th>Fonction</th>
                  </tr>
                </thead>
                <tbody>

                  {tasks.map((task, index) => (
                    <tr key={task.task_id}>
                      <td>
                        <i onClick={(e) => confirm2(e, task.task_id)} className="pi pi-trash cursor-pointer text-gray-500 hover:text-red-500"></i>
                      </td>

                      <td>{index + 1}</td>
                      <td>{task.task_name}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
      <ConfirmDialog />
      <Toast ref={toast} />
    </Fragment>
  );
};
